var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',_vm._b({on:{"click":function($event){return _vm.$emit('click')},"mouseenter":function($event){return _vm.$emit('hover')}}},'li',_vm.$attrs,false),[_vm._t("title"),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }